<section class="page-container">
  <div class="flex min-w-0 flex-wrap items-center justify-between gap-2">
    <h1 class="main-heading min-w-0">General Enquiry</h1>
    <app-navpath class="hidden md:block" />
  </div>

  <div class="content-container">
    <section class="content-container">
      <h2 class="sub-heading w-full border-b">Search Criteria</h2>
      <app-data-form
        class="general-enquiry-search-form"
        [dataFields]="searchCriteria"
        [dataName]="'searchCriteria'"
        (clickSearch)="search($event)"
      />
    </section>

    <section class="content-container">
      <h2 class="sub-heading w-full border-b">Search Result</h2>
      <app-data-form
        [dataFields]="searchResult"
        [dataName]="'searchResult'"
      />
    </section>
  </div>

  <div *ngIf="general_enquiry_data.length > 0" class="content-container w-full overflow-x-auto">
    <app-data-table
      class="block min-w-[70rem]"
      [tableHeaders]="general_enquiry_headers"
      [tableEntries]="general_enquiry_data"
      (edit)="editEntry($event)"
    />
  </div>
</section>
